import React, { useState } from 'react';
import { Modal, Box, TextField } from '@mui/material';
import Button from '@/components/CustomButtons/Button';
import { modalStyle } from '@/views/Clients/Claim';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';

export default function DeclineConfirmationModal({
  open,
  onClose,
  onConfirm,
  children,
}) {
  const [comment, setComment] = useState('');
  const [attempted, setAttempted] = useState(false);

  const handleClose = () => {
    setComment('');
    setAttempted(false);
    onClose(false);
  };

  const handleConfirm = () => {
    if (comment.trim().length === 0) {
      setAttempted(true);
      return;
    }
    onConfirm(comment);
    setComment('');
    setAttempted(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={modalStyle}
        style={{
          width: '500px',
        }}
        className='makeStyles-card-96'
        noValidate
        autoComplete='off'>
        <CardHeader style={{ transform: 'translateY(-50%)' }} color='primary'>
          <h6>Confirm Action</h6>
        </CardHeader>
        <CardBody>
          {children}

          <TextField
            fullWidth
            label='Comment'
            multiline
            rows={3}
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
              if (attempted && e.target.value.trim().length > 0) {
                setAttempted(false);
              }
            }}
            variant='outlined'
            placeholder='Please provide a reason for declining this refund...'
            style={{ marginTop: '20px' }}
            required
            error={attempted && comment.trim().length === 0}
            helperText={
              attempted && comment.trim().length === 0
                ? 'Comment is required'
                : ''
            }
          />

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              marginTop: '30px',
            }}>
            <Button
              color='rose'
              onClick={handleClose}
              type='button'
              variant='contained'>
              Cancel
            </Button>
            <Button
              color='primary'
              onClick={handleConfirm}
              type='button'
              variant='contained'
              style={{ marginLeft: '10px' }}>
              Confirm
            </Button>
          </div>
        </CardBody>
      </Box>
    </Modal>
  );
}
